import { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../../../../../components/Footer/Footer";
import InnerNav from "../../../../../components/InnerNav/InnerNav";
import { useFormData } from '../../ContextData/ContextData';
import "./char.scss";

export default function CharDasha() {
  const {userData} = useFormData();
  const [dashaData, setDashaData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await axios.get(
          "https://core-c343.onrender.com/api/char-dasha",
          {
            params: {
              year: userData.year,
              month: userData.month,
              day: userData.day,
              hour: userData.hour,
              minute: userData.minute,
            },
          }
        );
        setDashaData(res.data);
      } catch (err) {
        console.error("Error fetching Char Dasha:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  // Helper: Parse antarDasha into structured format
  const parseAntarDasha = (antarList) => {
    const structured = [];
    let current = null;

    antarList.forEach((line) => {
      if (line.startsWith("------------------------")) {
        if (current) structured.push(current);

        const cleaned = line.replace(/[-\n]/g, "").trim();
        const parts = cleaned.split(" ");
        const planet = parts[0] || "";
        const years = parts[1] ? parts[1] + " " + (parts[2] || "") : "";

        current = { planet, years, sub: [] };
      } else if (current) {
        current.sub.push(line);
      }
    });

    if (current) structured.push(current);
    return structured;
  };

  if (loading) return <p>Loading Char Dasha...</p>;
  if (!dashaData) return <p>No data available</p>;

  const antarStructured = parseAntarDasha(dashaData.antarDasha);

  return (
    <div className="char-dasha-container">
      <InnerNav />
      <h1 className="char-dasha-title">Char Dasha</h1>

      <p className="char-dasha-moon">
        🌙 Moon Sign: <strong>{dashaData.moonSign}</strong>
      </p>
      <p className="char-dasha-birth">
        📅 Birth Date: <strong>{dashaData.birthDate}</strong>
      </p>

      {/* Summary Section */}
      <div className="char-dasha-summary">
        <h2>Main Periods (Summary)</h2>
        <div className="char-dasha-grid">
          {dashaData.summary.map((s, idx) => (
            <div key={idx} className="char-dasha-summary-item">
              <p>{s}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Antar Dasha Section */}
      <div className="char-dasha-antar">
        <h2>Antar Dasha (Sub Periods)</h2>
        <div className="char-dasha-grid">
          {antarStructured.map((block, idx) => (
            <div
              key={idx}
              className={`char-dasha-column ${idx === 5 ? "highlight" : ""}`}
            >
              <p className="char-dasha-header">-------------</p>
              <p className="char-dasha-header">
                {block.planet} - {block.years}
              </p>
              <p className="char-dasha-header">-------------</p>

              {block.sub.map((s, i) => (
                <p key={i}>{s}</p>
              ))}
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}
